// :cow: Cosmose CONFIDENTIAL :iso:
export interface LanguageState {
  language: string;
}

export const initialState: LanguageState = {
  language: null,
};
